// Types used for styled components

export const fontFamilyBase = '"Roboto", Helvetica, Arial, sans-serif';
export const fontFamilyHeading = '"IBM Plex Sans", "Roboto", Helvetica, Arial, sans-serif';
export const fontFamilyDisplay =
  '"IBM Plex Sans Condensed", "Roboto", Helvetica, Arial, sans-serif';

export const fontWeight = {
  regular: 400,
  medium: 500,
  bold: 700,
  book: 400,
};

export const fontSize = {
  xs2: '10px',
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '20px',
  xl: '24px',
  xl2: '32px',
  xl3: '40px',
  xl4: '48px',
  xl5: '64px',
};

export const lineHeights = {
  xs: '16px',
  sm: '20px',
  md: '24px',
  lg: '28px',
  xl: '36px',
  xl2: '44px',
  xl3: '56px',
  xl4: '64px',
};

export const letterSpacing = {
  tighter: '-1.0px',
  tight: '-0.4px',
  normal: '0.0px',
  wide: '0.4px',
};
